import { LayerDefinition } from './types';

export const windsDefinition: LayerDefinition = {
  id: 'winds',
  name: 'Surface Winds & Gusts',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '💨',
  description: '10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.',
  sourceModels: ['hrrr', 'rrfs', 'gfs', 'rdps', 'ecmwf', 'icon13', 'RTMA (Obs)'],
  outputModels: ['Vector directional JSON (wind_grid.json)', 'Magnitude .pmtiles per model'],
  config: {
    defaultModel: 'hrrr'
  }
};

export default windsDefinition;
